export function HeaderBar() {
    return <header className="header">Wordle</header>;
}
